import { EnvelopeIcon, PhoneIcon } from "@heroicons/react/24/outline";
import { classNames } from "../utils/appUtils";
import Avatar from "./Avatar";
import { Strong } from "./catalyst/text";

interface UserViewProps {
  member: any;
  strikeThrough?: boolean;
  noTitle?: boolean;
}

export const UserView: React.FC<UserViewProps> = ({
  member,
  strikeThrough,
  noTitle,
}) => {
  if (!member) {
    return <div className="flex-1">No member</div>;
  }
  return (
    <div className="flex-1 flex flex-row items-center">
      <Avatar
        firstName={member.firstName}
        lastName={member.lastName}
        imageUrl={`/api/static/images/${member.profilePicture}`}
        className="h-8 w-8 rounded-full"
      />
      <div className="pl-1">
        <Strong
          className={classNames(
            "text-md font-semibold",
            strikeThrough ? "line-through" : ""
          )}
        >
          {noTitle ? "" : member.title} {member.firstName} {member.lastName}
        </Strong>
        {member.email && (
          <div>
            <div className="text-gray-500 dark:text-gray-300 flex items-center">
              <EnvelopeIcon className="h-4 w-4 mr-1 text-gray-500 dark:text-gray-300" />
              {member.email}
            </div>
            <div className="text-gray-500 dark:text-gray-300 flex items-center">
              <PhoneIcon className="h-4 w-4 mr-1 text-gray-500 dark:text-gray-300" />
              {member.phone}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
